import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueCookies from 'vue-cookies';
import FlagIcon from 'vue-flag-icon';
import App from './App.vue';
import { router } from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuex);

Vue.use(FlagIcon);
Vue.use(VueI18n);
Vue.use(VueCookies);

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    'en': require('@/assets/languages/en.json'),
    'fr': require('@/assets/languages/fr.json')
  }
})

export default i18n;


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');